import { classNames } from "@greeter/util";
import { AnimatePresence, motion } from "motion/react";
import css from "./Spinner.module.scss";
import { PulsingGreeter } from "./PulsingGreeter";
import { Alert } from "../Alert";
import { Ellipsis } from "./Ellipsis";

export type SpinnerProps = {
  reason?: string | false;
};
export function Spinner({ reason }: SpinnerProps) {
  return (
    <AnimatePresence>
      {reason && reason !== "" && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={css.SpinnerContainer}
        >
          <div
            onClick={(ev) => {
              ev.stopPropagation();
              ev.preventDefault();
            }}
            {...classNames(css.Backdrop)}
          />
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            className={css.LoadingWindow}
          >
            <AnimatePresence mode="popLayout">
              <Alert key="alert">
                <AnimatePresence mode="popLayout">
                  <motion.div
                    key="loading"
                    layout="position"
                    className={css.LogoContainer}
                    initial={{ x: -20, opacity: 0, filter: "blur(5px)" }}
                    animate={{ x: 0, opacity: 1, filter: "blur(0)" }}
                    exit={{ x: -20, opacity: 0, filter: "blur(5px)" }}
                  >
                    <PulsingGreeter />
                  </motion.div>
                  {!!reason && (
                    <motion.div
                      key={reason.trim().length > 0 ? reason : "Bip bup bip..."}
                      layout="position"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "end",
                        gap: 3,
                      }}
                      initial={{ y: -30, filter: "blur(5px)", opacity: 0 }}
                      animate={{ y: 0, filter: "blur(0)", opacity: 1 }}
                      exit={{ y: 30, filter: "blur(5px)", opacity: 0 }}
                      className={css.Reason}
                    >
                      {reason.trim().length > 0 ? (
                        <>
                          {reason}
                          <Ellipsis />
                        </>
                      ) : (
                        <>"Bip bup bip"</>
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>
              </Alert>
            </AnimatePresence>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
